import React from "react";
import Page from "../../common/page/Page";
import BlogPostBlock from "./BlogPostBlock";

export default function BlogPostPage(props) {
  return (
    <Page className="BlogPostPage">
      <Page.Content className="spaced-children">
        <BlogPostBlock />
      </Page.Content>
    </Page>
  );
}
